<template>
  <ViewCustomData entityName="device" entitySpec="data" serviceName="BaseService" :columns="FACILITY_DEVICE_COLUMNS"
    :dictionary="FACILITY_DEVICE_DICTIONARY" :masterDetail="{ facility_id: facilityId }" ref="viewFacilityDevice"
    :paginator="false" mode="edit" :requiredFieldsTable="{
      source_id: true,
      device_name: true,
      device_actual: true,
    }" :prepareUpdate="prepareUpdate" :prepareInsert="prepareInsert" :beforeOpenNewRow="beforeOpenNewRow" />
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { FACILITY_DEVICE_DICTIONARY, FACILITY_DEVICE_COLUMNS } from './facilityConstants';

const props = defineProps({
  facilityId: {
    type: [Number, String],
    required: true,
  },
})

const viewFacilityDevice = ref(null);

const prepareUpdateData = (data) => {
  return {
    device_id: data.device_id,
    source_id: data.source_id,
    device_name: data.device_name,
    device_actual: data.device_actual,
  };
}

const prepareUpdate = (rowData) => {
  return prepareUpdateData(rowData);
}

const prepareInsert = (rowData) => {
  const data = prepareUpdateData(rowData);
  data.facility_id = props.facilityId;
  return data;
}

const beforeOpenNewRow = (rowData) => {
  rowData.device_actual = true;
}
</script>